import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import _compact from 'lodash/compact';
import classes from './ChatConversationLoading.module.scss';

const ChatConversationLoading = (props) => {
  const styleGroup = _compact([classes.loadingMessage, props.show ? classes.show : '', props.className]).join(' ');

  return (
    <div className={styleGroup}>
      <div className={classes.spinner} />
      <FormattedMessage
        id="components.chat.conversation.loading"
        description="More (older) messages are being loaded to the conversation window"
        defaultMessage="Loading&hellip;"
      />
    </div>
  );
};

ChatConversationLoading.propTypes = {
  show: PT.bool,
  className: PT.string
};

export default ChatConversationLoading;
